"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const notification = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        sendSupportNotification: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/notifications/support`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
    };
};
exports.default = notification;
